<!--
  1) disableOutsideClick - If true, clicking outside the modal content won't close it
  2) title - Set the header title for the modal
  2) size - Set max-width for the modal, based on tailwindcss max-width
        sm   :  max-w-screen-sm	  : 640px;
        md   :  max-w-screen-md	  : 768px;
        lg   :  max-w-screen-lg	  : 1024px;
        xl   :  max-w-screen-xl	  : 1280px;
        2xl  :  max-w-screen-2xl  : 1536px;
 -->

<template>
  <div
    :class="{'absolute inset-0 z-50 flex items-center justify-center bg-gray-700 bg-opacity-50': size !== 'search',
      'absolute inset-0 z-50 flex items-start justify-center pt-16 pl-10 bg-gray-700 bg-opacity-50': size === 'search'
     }"
    @click.stop="handleBackgroundClick"
  >
    <div class="bg-white slide-top rounded flex flex-column w-full relative" :class="sizeClass">
      <div v-if="title" class="text-blueGray-700 select-none flex justify-between py-3.5 px-5 items-center text-base font-semibold">
        <div class="flex items-center w-full truncate">
          <div v-show="sequence_icon" class="mr-2">
            <div class="flex items-center justify-center rounded-full h-7 w-7 bg-purple-light">
              <img src="/static/roundtable_icons/sequence_icon.svg" class="w-3.5 h-3.5 pl-0.5" />
            </div>
          </div>
          <div v-show="genie_icon" class="mr-3">
            <i class="fa-solid fa-wand-magic-sparkles text-pinky"></i>
          </div>
          <div class="w-full truncate font-poppins font-semibold text-lg text-blueGray-800">
            <div :title="title" class="truncate w-full flex items-center space-x-3">
              <span>{{ title }}</span>
              <div v-if="isBeta === true" class="flex items-center justify-center w-12 h-6 text-xs text-pinky bg-pink-100 rounded-full border border-solid border-pinky text-center font-manrope">
                BETA
              </div>
            </div>
            <span class="underline cursor-pointer">
              {{ title_link }}
            </span>
          </div>
        </div>
        <button
          v-if="showCloseButton === true"
          @click="closeDialog"
          class="w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer text-lg flex items-center justify-center hover:text-primary hover:bg-primary-new_light text-blueGray-700"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
    props: {
      isBeta: {
        type: Boolean,
        default() {
          return false;
        }
      },
      disableOutsideClick: {
        type: Boolean,
        default() {
          return false;
        },
      },
      size: {
        type: String,
        default() {
          return 'md';
        },
      },
      title: {
        type: String,
        default() {
          return '';
        },
      },
      showCloseButton: {
        type: Boolean,
        default: true,
      },
      title_link: {
        type: String,
        default() {
          return '';
        },
      },
      sequence_icon: {
        type: Boolean,
        default() {
          return false;
        },
      },
      genie_icon: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    methods: {
      closeDialog() {
        this.$emit('close');
      },
      handleBackgroundClick() {
        if (!this.disableOutsideClick) {
          this.closeDialog(false);
        }
      },
    },
    computed: {
      sizeClass() {
        return {
          'max-w-screen-sm h-2/6 rounded-lg': this.size == 'xs',
          'h-full sm:max-w-screen-sm sm:h-1/2 rounded-lg': this.size == 'sm',
          'h-full max-w-screen-xs sm:h-4/6 rounded-lg':
            this.size === 'sequence_size',
          'h-full max-w-screen-xs sm:h-2/6 rounded-lg':
            this.size === 'dessassociate_sequence_roundtable',
          'max-w-screen-sm mt-10 mb-10 rounded-lg': this.size === 'relative_sm',
          'h-full max-w-screen-sm sm:h-4/5 rounded-lg':
            this.size === 'generating_error',
          'h-full max-w-screen-sm sm:h-3/6 rounded-lg':
            this.size === 'generating',
          'h-full sm:max-w-screen-sm md:max-w-screen-md md:h-3/5 rounded-lg':
            this.size == 'md',
          'h-full sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg rounded-lg lg:h-5/6':
            this.size == 'lg',
          'h-full sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl lg:h-5/6 rounded-lg':
            this.size == 'xl',
          'h-full sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl 2xl:h-5/6 rounded-lg':
            this.size == '2xl',
          'sm:max-w-screen-sm md:max-w-screen-md relative md:h-auto lg:h-auto xl:h-auto max-h-screen h-full sm:max-w-screen-sm rounded-lg':
            this.size == 'relative',
          'sm:max-w-screen-sm md:max-w-screen-md relative md:h-auto lg:h-auto xl:h-auto top-0 max-h-screen h-full sm:max-w-screen-sm rounded-lg':
            this.size == 'search',
          'sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg relative md:h-auto lg:h-auto xl:h-auto max-h-screen h-full rounded-lg':
            this.size == 'relative_lg',
          'h-full sm:max-w-screen-sm md:max-w-screen-md md:h-4/5 rounded-lg':
            this.size == 'md_xl',
          'h-full max-w-screen-xs sm:h-auto rounded-lg':
            this.size === 'confirm_size',
          'h-full choose sm:h-auto rounded-lg': this.size === 'choose_options',
          
        };
      },
    },
  };
</script>
<style>
  .choose {
    max-width: 40rem;
  }
</style>



// WEBPACK FOOTER //
// plDialog.vue?1a44efce